import React, { Component } from 'react';
import { translate } from '../../../../services';
import { SvgImage } from '../../../../components';
import { PropTypes } from 'prop-types';
import { accessoriesIcon } from '../../../../../style/images';

class ConfigureByCodeComponent extends Component {
  constructor() {
    super();
    this.setInputField = this.setInputField.bind( this );
    this.handleKeyDown = this.handleKeyDown.bind( this );
    this.handleClick = this.handleClick.bind( this );
  }

  setInputField( e ) {
    this.input = e;
  }

  handleKeyDown( e ) {
    if ( e.keyCode === 13 ) {
      this.handleClick();
    }
  }

  handleClick() {
    this.props.configure( this.input.value );
  }

  render() {
    return (
      <div className="configure-by-code">
        <input 
          ref={ this.setInputField } 
          onKeyDown={ this.handleKeyDown } 
          placeholder={ translate( 'Enter speaking code' ) } 
        />
        <SvgImage className="search-icon" source={ accessoriesIcon } onClick={ this.handleClick } toolTip={ translate( 'Configure by code' ) }/>
      </div>
    );
  }
}

ConfigureByCodeComponent.propTypes = {
  configure: PropTypes.func.isRequired
};

export const ConfigureByCode = ConfigureByCodeComponent;